import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
export const BaseWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="relative h-full bg-transparent pb-14 md:overflow-hidden md:rounded-sm md:bg-white md:pb-0">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};